import type { FundingApplicationSchemas } from "api-types";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useCustomerAppConfig } from "undercarriage";

import { getFundingApplicationStagesQueryOptions } from "../../../queries/funding-application-configuration/queries";

export const useStageOptOutCheckbox = (
  documentType: FundingApplicationSchemas.DocumentType
): {
  canOptOutOfStage?: boolean;
} => {
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: fundingApplicationStages } = useSuspenseQuery(getFundingApplicationStagesQueryOptions(customerDomain));

  if (documentType === "profit-and-loss" || documentType === "balance-sheet") {
    return {
      canOptOutOfStage: !!fundingApplicationStages.accounting?.canOptOut,
    };
  }
  const stage = fundingApplicationStages.documents?.find((stage) => stage.documentType === documentType);
  return {
    canOptOutOfStage: !!stage?.canOptOut,
  };
};
